import { render } from "./ErrorIcon.vue?vue&type=template&id=34d594f4"
import script from "./ErrorIcon.vue?vue&type=script&lang=js"
export * from "./ErrorIcon.vue?vue&type=script&lang=js"
script.render = render

export default script